import React from 'react'; 
import classes from './FAQBar.scss';

const FAQBar = (props) => (
    <div className={`${[classes.Container, props.index === props.accordionindex ? classes.ContainerActive : null].join(' ')} u-flex justify-content-between align-items-center u-hover-textColorWhite`} {...props}>
        <p className={`u-fontWeightRegular u-textColorInherit`}><span className={`mr-3`}>{props.index}.</span>{props.children}</p>
    </div>
);

export default FAQBar;


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelFAQ/FAQBar/FAQBar.js